import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconLookup } from '@fortawesome/fontawesome-svg-core';

type Props = {
  icon: IconLookup;
  text: string;
};

export default function Feature({ icon, text }: Props) {
  return (
    <div className="flex items-center flex-col justify-center">
      <FontAwesomeIcon icon={icon} size="2x" className="text-primary-600 mb-3" />
      <p className="text-sm lg:text-base text-center font-semibold">{text}</p>
    </div>
  );
}
